var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadedThumb),expression:"loadedThumb"}],class:_vm.getClass,style:(_vm.getImgStyle),attrs:{"id":"image","src":_vm.getSrcThumb,"alt":"immagine profilo utente"},on:{"load":_vm.loadedThumbImage}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18f52472","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar.vue
// module id = 6FTN
// module chunks = 1